import "./TableHeader.css";

const TableHeader = ({
  columns,
  sortConfig,
  handleSort,
  handleSelectAll,
  isAllSelected,
}) => {
  const handleSortKeyDown = (event, field) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSort(field);
    }
  };

  return (
    <thead className="safety-table-header">
      <tr className="safety-table-header__row">
        <th className="safety-table-header__cell safety-table-header__cell--checkbox">
          <input
            className="safety-table-header__checkbox"
            type="checkbox"
            onChange={handleSelectAll}
            checked={isAllSelected}
            aria-label="Select all rows"
          />
        </th>

        {columns.slice(0, 6).map((column, index) => {
          const isActive = sortConfig.field === column.field;
          const sortDirection = isActive ? sortConfig.direction : "none";

          return (
            <th
              key={index}
              className={`safety-table-header__cell safety-table-header__cell--sortable ${
                isActive ? "safety-table-header__cell--active" : ""
              } ${
                isActive && sortConfig.direction === "asc"
                  ? "safety-table-header__cell--asc"
                  : ""
              } ${
                isActive && sortConfig.direction === "desc"
                  ? "safety-table-header__cell--desc"
                  : ""
              }`}
              onClick={() => handleSort(column.field)}
              onKeyDown={(event) => handleSortKeyDown(event, column.field)}
              role="button"
              tabIndex={0}
              aria-sort={
                sortDirection === "asc"
                  ? "ascending"
                  : sortDirection === "desc"
                    ? "descending"
                    : "none"
              }
            >
              <span className="safety-table-header__label">{column.label}</span>

              <span className="safety-table-header__sort-icon">
                {isActive ? (
                  sortConfig.direction === "asc" ? (
                    <i className="fas fa-sort-up" />
                  ) : (
                    <i className="fas fa-sort-down" />
                  )
                ) : (
                  <i className="fas fa-sort" />
                )}
              </span>
            </th>
          );
        })}

        <th className="safety-table-header__cell safety-table-header__cell--actions">
          Actions
        </th>
      </tr>
    </thead>
  );
};

export default TableHeader;
